import { BioPage } from "../components/BioPage";
import { IMAGES } from "../config/site";

const SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Attorney",
  name: "Ronald K. Nolen",
  jobTitle: "Founder & Managing Attorney",
  worksFor: { "@type": "LegalService", name: "The Law Office of Ronald K. Nolen, LLC" },
  alumniOf: ["Fisk University", "Western Michigan University Cooley Law School"],
  areaServed: "Chicago, Illinois",
  url: "https://www.rknolenlaw.org/team/ronald-k-nolen",
};

const INTRO = [
  "Attorney Ronald K. Nolen, Esq. is a Chicago-born attorney, educator, and legal advocate with a distinguished career spanning real estate, contract law, and sports and entertainment law.",
  "A lifelong Chicagoan, he graduated with high honors from Lincoln Park High School before earning his Bachelor of Arts in Political Science, with a Pre-Law concentration, cum laude, from Fisk University.",
  "Attorney Nolen earned his Juris Doctor from Western Michigan University Cooley Law School. He is licensed to practice law in the State of Illinois and is admitted to the United States District Court for the Northern District of Illinois.",
  "Throughout his legal career, Attorney Nolen has represented thousands of clients across 13 Illinois counties. His litigation experience includes successfully defending more than 1,000 homeowners in mortgage-foreclosure actions involving major financial institutions. He has also represented clients in real estate and contract matters, and in matters involving sports and entertainment law.",
  "In addition to practicing law, Attorney Nolen is a tenured professor at Olive-Harvey College, where he is committed to educating and mentoring future leaders. He is the founder and CEO of The Law Office of Ronald K. Nolen, LLC, with a concentrated focus on real estate, sports, and entertainment law.",
  "His entertainment practice has helped clients pursue and secure opportunities connected to nationally recognized television programs, including Love & Hip Hop: New York, Bad Girls Club, and Windy City Live, as well as international radio and film productions.",
  "Attorney Nolen has also served as legal counsel to current and former professional athletes, including NFL and NBA players, as well as an Olympic track and field athlete.",
  "Whether advocating in court, advising business and entertainment clients, negotiating agreements, or mentoring students, Attorney Nolen remains committed to protecting his clients' interests and creating pathways for success. Outside of his professional work, he enjoys spending time with family and friends.",
];

const SECTIONS = [
  {
    title: "Education", type: "pairs",
    items: [
      { label: "Fisk University", value: "Bachelor of Arts in Political Science, Pre-Law concentration, cum laude" },
      { label: "Western Michigan University Cooley Law School", value: "Juris Doctor" },
    ],
  },
  {
    title: "Admissions", type: "list",
    items: ["State of Illinois", "U.S. District Court for the Northern District of Illinois"],
  },
  {
    title: "Experience Highlights", type: "list",
    items: [
      "Thousands of clients represented",
      "Matters handled across 13 Illinois counties",
      "More than 1,000 homeowners defended in mortgage-foreclosure actions",
      "Experience serving businesses, entertainers, athletes, property owners, and individuals",
      "Tenured professor at Olive-Harvey College",
    ],
  },
  {
    title: "Primary Practice Focus", type: "list",
    items: ["Real Estate Law", "Sports Law", "Entertainment Law", "Contract Law"],
  },
];

export default function RonaldBio() {
  return (
    <BioPage
      testid="ronald-bio"
      seo={{
        title: "Ronald K. Nolen | Founder & Managing Attorney | Nolen Law Chicago",
        description:
          "Ronald K. Nolen is a Chicago attorney and educator with experience across real estate, commercial litigation, sports, and entertainment law, admitted in Illinois and federal court.",
        path: "/team/ronald-k-nolen",
        image: IMAGES.ronald,
        schema: SCHEMA,
      }}
      image={IMAGES.ronald}
      imageAlt="Ronald K. Nolen, Founder and Managing Attorney of The Law Office of Ronald K. Nolen, LLC"
      eyebrow="Founder & Managing Attorney"
      name="Ronald K. Nolen, Esq."
      subheadline="Attorney, educator, negotiator, and Chicago-rooted advocate."
      intro={INTRO}
      sections={SECTIONS}
      finalHeadline="Speak With Ronald About Your Matter"
    />
  );
}
